import { render, staticRenderFns } from "./DataSourceHeader.vue?vue&type=template&id=35eb3761&scoped=true"
import script from "./DataSourceHeader.vue?vue&type=script&lang=js"
export * from "./DataSourceHeader.vue?vue&type=script&lang=js"
import style0 from "./DataSourceHeader.vue?vue&type=style&index=0&id=35eb3761&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eb3761",
  null
  
)

export default component.exports